import { userPostNotificationsRead } from '@/modules/user/userActions';
import { useDispatch } from 'react-redux';

export const useNotificationMutation = () => {
	const dispatch = useDispatch();

	const mutate = () => dispatch(userPostNotificationsRead());

	return { mutate };
};
